import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerDiscoverRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-discover',
	path: '/jira/assets/discover/data-manager',
	exact: true,
};
